<template>
    <div class="case-wrapper" :class="shortname + ' ' + position + ' ' + loadedState">
        <div class="case-loader" v-if="loadedState === 'not-loaded'">
            <div class="spinner">
                <div class="dot1"></div>
                <div class="dot2"></div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-7" v-if="position === 'right'"></div>
                <div class="col-lg-5 align-self-center">
                    <div class="case-inner">
                        <!--<img :src="'/static/images/cases/new/' + shortname + '_logo.png'"/>-->
                        <h3>
                            {{ name }}
                        </h3>
                        <p>
                            {{ type }}
                        </p>
                        <div class="description">
                            <slot name="description"></slot>
                        </div>
                        <!--<div class="case-quote">
                            <i class="fa fa-quote-left fa-fw"></i>
                            <i class="fa fa-quote-right fa-fw"></i>
                            <slot name="quote"></slot>
                            <br>
                            <b>{{ author }}</b><br>
                            <span>{{ job }}, {{ name }}</span>
                        </div>-->
                        <!--<p>
                            <a href="#" class="btn btn-light btn-rounded">
                                Læs mere
                            </a>
                        </p>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props: ['job', 'author', 'name', 'type', 'shortname', 'position'],
        data () {
            return {
                loadedState: 'not-loaded'
            }
        },
        mounted () {
            var self = this
            if (this.shortname === 'julehjaelpen') {
                $('<img/>').attr('src', '/static/images/cases/new/jh_hd.jpg').on('load', function () {
                    self.loadedState = 'loaded'
                })
            }
            if (this.shortname === 'volkswagen') {
                $('<img/>').attr('src', '/static/images/cases/new/vw_hd.jpg').on('load', function () {
                    self.loadedState = 'loaded'
                })
            }
            if (this.shortname === 'quooker') {
                $('<img/>').attr('src', '/static/images/cases/new/q_hd.jpg').on('load', function () {
                    self.loadedState = 'loaded'
                })
            }
            if (this.shortname === 'apmp') {
                $('<img/>').attr('src', '/static/images/cases/new/apmp_hd.jpg').on('load', function () {
                    self.loadedState = 'loaded'
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .case-loader{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 25px;
    }
    .spinner {
        margin: 100px auto;
        width: 30px;
        height: 30px;
        position: relative;
        text-align: center;
        -webkit-animation: sk-rotate 2.0s infinite linear;
        animation: sk-rotate 2.0s infinite linear;
    }
    .dot1, .dot2 {
        width: 60%;
        height: 60%;
        display: inline-block;
        position: absolute;
        top: 0;
        background-color: #fff;
        border-radius: 100%;
        opacity: 0.5;

        -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
        animation: sk-bounce 2.0s infinite ease-in-out;
    }
    .dot2 {
        top: auto;
        bottom: 0;
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }
    @-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
    @keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}
    @-webkit-keyframes sk-bounce {
        0%, 100% { -webkit-transform: scale(0.0) }
        50% { -webkit-transform: scale(1.0) }
    }
    @keyframes sk-bounce {
        0%, 100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        } 50% {
              transform: scale(1.0);
              -webkit-transform: scale(1.0);
          }
    }
    .description{
        font-size: 0.8rem;
        font-weight: 300;
    }
    .container, .row{
        height: 100%;
    }
    h3, p, .case-quote{
        margin-bottom: 20px;
    }
    p{
        font-weight: 300;
    }
    .right *{
        text-align: right;
    }
    *{
        color: #fff;
    }
    .case-wrapper{
        padding: 80px 0;
        height: 100vh;
        transition: 1s ease all;
        position: relative;
    }
    .case-inner{
        background: rgba(255,255,255,0.95);
        // background: linear-gradient(150deg, rgba(#fff, 0.8) 15%, rgba(#fff, 0.8) 70%), url('/static/images/bg.svg') center center;
        border-radius: 4px;
        padding: 30px;
        *, a{
            color: #333 !important;
            border-color: #333 !important;
        }
        img{
            position: absolute;
            top: 30px;
            right: 45px;
            max-width: 100px;
            max-height: 50px;
        }
        p{
            margin: 0;
        }
        p:first-of-type{
            margin-bottom: 20px;
        }
        h3{
            font-weight: 300;
        }
    }
    .right img{
        left: 45px;
    }
    .case-quote{
        padding: 10px 40px;
        background: rgba(255,255,255,0.9);
        border-radius: 10px;
        color: #212529;
        font-size: 0.75rem;
        position: relative;
    }
    .case-quote *{
        color: #212529;
        opacity: 0.9;
    }
    .fa-quote-left{
        position: absolute;
        top: 12px;
        left: 12px;
        font-size: 1rem;
    }
    .fa-quote-right{
        position: absolute;
        bottom: 12px;
        right: 12px;
        font-size: 1rem;
    }
    .quooker{
        background: url('/static/images/cases/new/q_blur.jpg');
        background-size: cover;
    }
    .quooker.loaded{
        background: url('/static/images/cases/new/q_hd.jpg');
        background-size: cover;
        // background-attachment: fixed;
    }
    .julehjaelpen{
        /* background: url('/static/images/cases/julehjaelpen.jpg') center center; */
        background: url('/static/images/cases/new/jh_blur.jpg');
        background-size: cover;
    }
    .julehjaelpen.loaded{
        background: url('/static/images/cases/new/jh_hd.jpg');
        background-size: cover;
        // background-attachment: fixed;
    }
    .volkswagen{
        background: url('/static/images/cases/new/vw_blur.jpg') center;
        background-size: cover;
    }
    .volkswagen.loaded{
        background: url('/static/images/cases/new/vw_hd.jpg') center;
        background-size: cover;
        // background-attachment: fixed;
    }
    .atea{
        background: url('/static/images/cases/atea.jpg') center;
        background-size: cover;
    }
    .apmp{
        background: url('/static/images/cases/new/apmp_blur.jpg') center;
        background-size: cover;
    }
    .apmp.loaded{
        background: url('/static/images/cases/new/apmp_hd.jpg') center;
        background-size: cover;
        // background-attachment: fixed;
    }
    .greenwell{
        // background: url('https://fjordhytter.dk/wp-content/uploads/2015/12/11080652_814207335320141_6764652302080963309_o1-1024x768-740x400.jpg') center;
        background: url('https://dihc.dk/wp-content/uploads/2015/01/DSCI1341.jpg');
        background-size: cover;
    }
</style>



// WEBPACK FOOTER //
// new-case.vue?f80c1c30